import styled, { keyframes, css } from 'styled-components';

// ===== ANIMAÇÕES TECNOLÓGICAS =====

// Animação para o grid tecnológico pulsante
export const techGridPulse = keyframes`
  0% { opacity: 0.3; }
  50% { opacity: 0.7; }
  100% { opacity: 0.3; }
`;

// Animação de gradiente em movimento
export const gradientMove = keyframes`
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
`;

// Animação de scanner holográfico
export const scannerEffect = keyframes`
  0% { left: -100%; }
  50% { left: 100%; }
  100% { left: -100%; }
`;

// Animação de pulso para bordas
export const pulseBorder = keyframes`
  0% { box-shadow: 0 0 0 0 rgba(0, 255, 255, 0.7); }
  70% { box-shadow: 0 0 0 5px rgba(0, 255, 255, 0); }
  100% { box-shadow: 0 0 0 0 rgba(0, 255, 255, 0); }
`;

// Animação de brilho pulsante
export const glowPulse = keyframes`
  0% { filter: drop-shadow(0 0 2px rgba(0, 200, 255, 0.3)); }
  50% { filter: drop-shadow(0 0 8px rgba(0, 200, 255, 0.8)); }
  100% { filter: drop-shadow(0 0 2px rgba(0, 200, 255, 0.3)); }
`;

// Animação para linhas de energia
export const energyLinesPulse = keyframes`
  0% { opacity: 0.2; height: 40%; }
  50% { opacity: 0.6; height: 70%; }
  100% { opacity: 0.2; height: 40%; }
`;

// Animação para o efeito de pulsação de energia
export const energyPulse = keyframes`
  0% { transform: scale(1); opacity: 0.3; }
  50% { transform: scale(1.2); opacity: 0.7; }
  100% { transform: scale(1); opacity: 0.3; }
`;

// Animação para o efeito de escaneamento de texto
export const textScan = keyframes`
  0% { background-position: -100% 0; }
  100% { background-position: 200% 0; }
`;

// Animação de rotação para o spinner
export const rotate = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

// Animação para o efeito de processamento de dados
export const dataProcessing = keyframes`
  0% {
    background-position: 0% 0%;
    opacity: 0.3;
    transform: scale(0.95);
  }
  25% {
    opacity: 0.7;
    transform: scale(1.02);
  }
  50% {
    opacity: 0.5;
    transform: scale(0.98);
  }
  75% {
    opacity: 0.8;
    transform: scale(1.05);
  }
  100% {
    background-position: 100% 100%;
    opacity: 0.3;
    transform: scale(0.95);
  }
`;

// Animação para pulso de dados durante processamento
export const dataPulse = keyframes`
  0% {
    box-shadow: 0 0 5px rgba(0, 200, 255, 0.3), 0 0 10px rgba(0, 200, 255, 0.2);
    border-color: rgba(0, 200, 255, 0.3);
  }
  25% {
    box-shadow: 0 0 15px rgba(0, 200, 255, 0.7), 0 0 20px rgba(0, 200, 255, 0.4);
    border-color: rgba(0, 200, 255, 0.7);
  }
  50% {
    box-shadow: 0 0 10px rgba(0, 200, 255, 0.5), 0 0 15px rgba(0, 200, 255, 0.3);
    border-color: rgba(0, 200, 255, 0.5);
  }
  75% {
    box-shadow: 0 0 20px rgba(0, 200, 255, 0.8), 0 0 25px rgba(0, 200, 255, 0.5);
    border-color: rgba(0, 200, 255, 0.8);
  }
  100% {
    box-shadow: 0 0 5px rgba(0, 200, 255, 0.3), 0 0 10px rgba(0, 200, 255, 0.2);
    border-color: rgba(0, 200, 255, 0.3);
  }
`;

// Animação para o fluxo de dados digital
export const digitalDataFlow = keyframes`
  0% {
    background-position: 0% 0%;
    opacity: 0.2;
  }
  50% {
    background-position: 50% 50%;
    opacity: 0.6;
  }
  100% {
    background-position: 100% 100%;
    opacity: 0.2;
  }
`;

// Animação de brilho para o contorno (mais intenso)
export const inputGlowPulse = keyframes`
  0% { box-shadow: 0 0 5px rgba(0, 200, 255, 0.3); }
  50% { box-shadow: 0 0 15px rgba(0, 255, 255, 0.6), 0 0 20px rgba(0, 200, 255, 0.4); }
  100% { box-shadow: 0 0 5px rgba(0, 200, 255, 0.3); }
`;

// Animação de brilho para o contorno (mais sutil para inputs)
export const inputGlowPulseSubtle = keyframes`
  0% { box-shadow: 0 0 3px rgba(0, 200, 255, 0.15); }
  50% { box-shadow: 0 0 8px rgba(0, 255, 255, 0.3), 0 0 12px rgba(0, 200, 255, 0.2); }
  100% { box-shadow: 0 0 3px rgba(0, 200, 255, 0.15); }
`;

// ===== COMPONENTES DE ESTILO TECNOLÓGICO =====

// Fundo tecnológico com gradiente animado
export const TechBackground = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 0;
  border-radius: 10px;
  pointer-events: none;
  height: 100%;
  width: 100%;
  
  /* Fundo com gradiente animado */
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(135deg, 
      rgba(0, 32, 64, 0.7) 0%, 
      rgba(0, 64, 128, 0.6) 25%,
      rgba(0, 96, 192, 0.5) 50%, 
      rgba(0, 64, 128, 0.6) 75%,
      rgba(0, 32, 64, 0.7) 100%);
    background-size: 400% 400%;
    animation: ${gradientMove} 10s ease infinite;
    z-index: -2;
    height: 100%;
    width: 100%;
  }
  
  /* Vinheta para dar profundidade */
  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: radial-gradient(circle at 50% 50%, transparent 30%, rgba(0, 16, 32, 0.6) 100%);
    z-index: -1;
    height: 100%;
    width: 100%;
  }
`;

// Linhas de grade tecnológica
export const CircuitLines = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 0;
  pointer-events: none;
  height: 100%;
  width: 100%;
  
  /* Linhas tecnológicas */
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: 
      linear-gradient(90deg, rgba(64, 128, 255, 0.1) 1px, transparent 1px),
      linear-gradient(0deg, rgba(64, 128, 255, 0.1) 1px, transparent 1px);
    background-size: 20px 20px;
    z-index: -1;
  }
  
  /* Linhas diagonais sutis */
  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: 
      linear-gradient(45deg, rgba(64, 128, 255, 0.05) 1px, transparent 1px),
      linear-gradient(-45deg, rgba(64, 128, 255, 0.05) 1px, transparent 1px);
    background-size: 40px 40px;
    z-index: -1;
    opacity: 0.5;
  }
`;

// Pontos de energia
export const TechParticles = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 0;
  pointer-events: none;
  height: 100%;
  width: 100%;
  
  /* Ponto de energia superior */
  &::before {
    content: '';
    position: absolute;
    top: 20%;
    left: 15%;
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background: rgba(0, 200, 255, 0.8);
    box-shadow: 0 0 10px 2px rgba(0, 200, 255, 0.6);
    animation: ${energyPulse} 4s infinite ease-in-out;
  }
  
  /* Ponto de energia inferior */
  &::after {
    content: '';
    position: absolute;
    bottom: 20%;
    right: 15%;
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background: rgba(0, 200, 255, 0.8);
    box-shadow: 0 0 10px 2px rgba(0, 200, 255, 0.6);
    animation: ${energyPulse} 4s infinite ease-in-out;
    animation-delay: -2s;
  }
`;

// Scanner holográfico
export const HolographicScanner = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 0;
  pointer-events: none;
  height: 100%;
  width: 100%;
  
  /* Linha de scanner horizontal */
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 2px;
    background: linear-gradient(
      to right,
      transparent,
      rgba(0, 200, 255, 0.2),
      rgba(0, 200, 255, 0.8),
      rgba(0, 200, 255, 0.2),
      transparent
    );
    box-shadow: 0 0 10px rgba(0, 200, 255, 0.5);
    opacity: 0.7;
    transform: translateY(-100%);
    animation: ${scannerEffect} 8s infinite ease-in-out;
    z-index: 1;
  }
`;

// Efeito de brilho de borda
export const BorderGlow = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 0;
  pointer-events: none;
  border-radius: 10px;
  box-shadow: inset 0 0 15px rgba(0, 200, 255, 0.3);
  animation: ${glowPulse} 4s infinite ease-in-out;
  height: 100%;
  width: 100%;
  
  /* Cantos brilhantes */
  &::before, &::after {
    content: '';
    position: absolute;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background: radial-gradient(circle, rgba(0, 200, 255, 0.4) 0%, transparent 70%);
    animation: ${energyPulse} 4s infinite ease-in-out;
  }
  
  &::before {
    top: 10px;
    left: 10px;
  }
  
  &::after {
    bottom: 10px;
    right: 10px;
    animation-delay: -2s;
  }
`;

// Estilo para botões de data com efeito tecnológico
export const TechButton = css`
  background-color: ${props => props.selected ? 'rgba(0, 200, 255, 0.3)' : 'rgba(10, 20, 35, 0.7)'};
  border: 1px solid ${props => props.selected ? 'rgba(0, 200, 255, 0.8)' : 'rgba(0, 200, 255, 0.3)'};
  border-radius: 6px;
  color: white;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  position: relative;
  overflow: hidden;
  box-shadow: ${props => props.selected ? '0 0 15px rgba(0, 200, 255, 0.4)' : '0 0 0 rgba(0, 0, 0, 0)'};
  transform: ${props => props.selected ? 'translateY(-2px)' : 'translateY(0)'};
  z-index: 1;
  
  &:hover {
    background-color: rgba(0, 200, 255, 0.2);
    border-color: rgba(0, 200, 255, 0.5);
    transform: translateY(-2px);
    box-shadow: 0 5px 15px rgba(0, 200, 255, 0.3);
  }
  
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    background-color: rgba(50, 50, 50, 0.3);
    border-color: rgba(100, 100, 100, 0.3);
    transform: translateY(0);
    box-shadow: none;
  }
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      90deg,
      transparent,
      rgba(0, 200, 255, 0.2),
      transparent
    );
    transition: all 0.3s ease;
    z-index: -1;
    animation: none;
  }
  
  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 2px;
    background: linear-gradient(
      to right,
      transparent,
      ${props => props.selected ? 'rgba(0, 200, 255, 0.8)' : 'rgba(0, 200, 255, 0.3)'},
      transparent
    );
    opacity: ${props => props.selected ? '1' : '0.5'};
    animation: none;
  }
  
  ${props => props.selected && css`
    /* Mantém o estilo selecionado sem animação */
  `}
`;

// Título com gradiente tecnológico
export const TechTitle = styled.h2`
  font-family: 'Orbitron', sans-serif;
  font-size: 1.5rem;
  font-weight: 700;
  text-align: center;
  margin-bottom: 20px;
  letter-spacing: 1px;
  background: linear-gradient(to right, #00c8ff, #00ffea);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  position: relative;
  
  &::after {
    content: '';
    position: absolute;
    bottom: -5px;
    left: 25%;
    width: 50%;
    height: 1px;
    background: linear-gradient(to right, transparent, rgba(0, 200, 255, 0.8), transparent);
  }
`;

// Estilo para título de seção
export const SectionTitle = styled.h3`
  font-family: 'Orbitron', sans-serif;
  font-size: 1.1rem;
  font-weight: 500;
  margin-bottom: 15px;
  letter-spacing: 0.5px;
  background: linear-gradient(to right, #00c8ff, #00ffea);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  text-align: center;
`;

// Container para grade de botões com efeito de fundo tecnológico
export const TechGridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(90px, 1fr));
  gap: 12px;
  margin-bottom: 20px;
  position: relative;
  width: 100%;
  box-sizing: border-box;
  z-index: 1;
  
  &::before {
    content: '';
    position: absolute;
    top: -5px;
    left: 0;
    right: 0;
    bottom: -5px;
    background: 
      linear-gradient(45deg, rgba(0, 200, 255, 0.03) 25%, transparent 25%),
      linear-gradient(-45deg, rgba(0, 200, 255, 0.03) 25%, transparent 25%),
      linear-gradient(45deg, transparent 75%, rgba(0, 200, 255, 0.03) 75%),
      linear-gradient(-45deg, transparent 75%, rgba(0, 200, 255, 0.03) 75%);
    background-size: 20px 20px;
    z-index: -1;
    border-radius: 8px;
    opacity: 0.3;
  }
`;

// Spinner de carregamento tecnológico
export const TechLoadingSpinner = styled.div`
  display: inline-block;
  width: 20px;
  height: 20px;
  margin-left: 10px;
  border: 2px solid rgba(0, 200, 255, 0.3);
  border-top: 2px solid rgba(0, 200, 255, 0.8);
  border-radius: 50%;
  animation: ${rotate} 1s linear infinite;
`;

// Botão de envio com estilo tecnológico
export const TechSubmitButton = styled.button`
  width: 100%;
  padding: 12px 20px;
  background-color: rgba(0, 200, 255, 0.2);
  color: white;
  border: 1px solid rgba(0, 200, 255, 0.5);
  border-radius: 6px;
  font-family: 'Orbitron', sans-serif;
  font-size: 1rem;
  font-weight: 500;
  letter-spacing: 1px;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  margin-top: 20px;
  text-transform: uppercase;
  
  &:hover {
    background-color: rgba(0, 200, 255, 0.3);
    box-shadow: 0 0 15px rgba(0, 200, 255, 0.4);
  }
  
  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      90deg,
      transparent,
      rgba(0, 200, 255, 0.2),
      transparent
    );
    transition: all 0.3s ease;
    z-index: 1;
    animation: ${scannerEffect} 3s infinite linear;
  }
`;

// Input com estilo tecnológico
export const TechInput = styled.input`
  width: 100%;
  padding: 12px 15px;
  background-color: rgba(10, 20, 35, 0.7);
  color: white;
  border: 1px solid rgba(0, 200, 255, 0.3);
  border-radius: 6px;
  font-family: 'Orbitron', sans-serif;
  font-size: 0.9rem;
  letter-spacing: 0.5px;
  transition: all 0.3s ease;
  box-sizing: border-box;
  animation: ${inputGlowPulseSubtle} 3s infinite ease-in-out;
  
  &:focus {
    outline: none;
    border-color: rgba(0, 200, 255, 0.8);
    box-shadow: 0 0 10px rgba(0, 255, 255, 0.4), 0 0 15px rgba(0, 200, 255, 0.3);
  }
  
  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }
`;

// Label com estilo tecnológico
export const TechLabel = styled.label`
  display: block;
  margin-bottom: 8px;
  font-family: 'Orbitron', sans-serif;
  font-size: 0.9rem;
  font-weight: 500;
  letter-spacing: 0.5px;
  background: linear-gradient(to right, #00c8ff, #00ffea);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;

// Grupo de formulário com estilo tecnológico
export const TechFormGroup = styled.div`
  margin-bottom: 20px;
  position: relative;
  z-index: 1;
`;

// Container de formulário com estilo tecnológico
export const TechFormContainer = styled.form`
  position: relative;
  z-index: 1;
`;
